import { render, staticRenderFns } from "./lms.vue?vue&type=template&id=4ddef5b7"
import script from "./lms.vue?vue&type=script&lang=js"
export * from "./lms.vue?vue&type=script&lang=js"
import style0 from "./lms.vue?vue&type=style&index=0&id=4ddef5b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports